import { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../services";
import { useLoading } from "../../../../components/Loading";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const MotorRTOForm = ({ editRTOData, onsubmit }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setCircleLoading } = useLoading();
  const isEdit = location.pathname.includes("/edit-motorRTO");
  const [rtoData, setRTOData] = useState({
    // rto information
    name: "",
    displayName: "",
    rtoCode: "",
    city: "",
    district: "",
    state: "",
    rtoRegion: "",
    rtoZone: "",
    isActive: true,

    // rto information status
    nameStatus: "unchecked",
    displayNameStatus: "unchecked",
    cityStatus: "unchecked",
    districtStatus: "unchecked",
    stateStatus: "unchecked",
    rtoRegionStatus: "unchecked",
    rtoZoneStatus: "unchecked",
    rtoCodeStatus: "unchecked",
  });
  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [rtoRegionOptions, setRtoRegionOptions] = useState([]);
  const [rtoZoneOptions, setRtoZoneOptions] = useState([]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      setCircleLoading(true);
      try {
        const [
          stateResponse,
          districtResponse,
          cityResponse,
          rtoZoneResponse,
          rtoRegionResponse,
        ] = await Promise.all([
          fetchData(`/reference/general/state?dropdown=true`),
          fetchData(`/reference/general/district?dropdown=true`),
          fetchData(`/reference/general/city?dropdown=true`),
          fetchData(
            `/reference/motor/key-value-store?dropdown=true&code=${DropDownConfig?.motorRTOZone}`
          ),
          fetchData(
            `/reference/motor/key-value-store?dropdown=true&code=${DropDownConfig?.motorRTORegion}`
          )
        ]);

        // State options
        if (stateResponse?.success) {
          setStateOptions(
            stateResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        } else {
          console.warn("Failed to fetch State dropdown data");
        }

        // District options
        if (districtResponse?.success) {
          setDistrictOptions(
            districtResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        } else {
          console.warn("Failed to fetch District dropdown data");
        }

        // City options
        if (cityResponse?.success) {
          setCityOptions(
            cityResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        } else {
          console.warn("Failed to fetch City dropdown data");
        }

        // RTO Zone options
        if (rtoZoneResponse?.success) {
          setRtoZoneOptions(
            rtoZoneResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        } else {
          console.warn("Failed to fetch RTO Zone dropdown data");
        }

        // RTO Region options
        if (rtoRegionResponse?.success) {
          setRtoRegionOptions(
            rtoRegionResponse.data?.items?.map((item) => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        } else {
          console.warn("Failed to fetch RTO Zone dropdown data");
        }
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (editRTOData) {
      setRTOData(editRTOData);
    }
  }, [editRTOData]);

  const handleRTODataChange = (event, selectEvent) => {
    let rtoState = { ...rtoData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "city":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              rtoState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              rtoState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "district":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              rtoState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              rtoState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "state":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              rtoState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              rtoState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "rtoRegion":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              rtoState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              rtoState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "rtoZone":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              rtoState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              rtoState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      rtoState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,50})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              rtoState[event.target.name + "Status"] = "success";
            } else {
              rtoState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "displayName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              rtoState[event.target.name + "Status"] = "success";
            } else {
              rtoState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "rtoCode":
          {
            const alphaNLenghthRegex = new RegExp(
              "^([A-Za-z0-9 -/:;@.#&]{2,20})$"
            );

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              rtoState[event.target.name + "Status"] = "success";
            } else {
              rtoState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        rtoState[event.target.name] = event.target.value;
      }
    }
    setRTOData(rtoState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      rtoData.nameStatus === "success" &&
      rtoData.cityStatus === "success" &&
      // rtoData.stateStatus === "success" &&
      rtoData.rtoRegionStatus === "success" &&
      rtoData.rtoZoneStatus === "success" &&
      rtoData.rtoCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(rtoData);
    }
  };

  return (
    <>
      <div>
        <CardContent sx={{ minHeight: "65vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    RTO Name*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="eg. Chennai"
                  value={rtoData.name}
                  onChange={handleRTODataChange}
                  error={rtoData.nameStatus === "error" ? true : false}
                  success={rtoData.nameStatus === "success" ? true : false}
                />
                {rtoData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be maximum 40 characters long and can contain
                      only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {isEdit && (
                <Grid size={{ xs: 12, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Display Name*
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="displayName"
                    placeholder="eg. Chennai RTO"
                    value={rtoData.displayName}
                    onChange={handleRTODataChange}
                    error={rtoData.displayNameStatus === "error" ? true : false}
                    success={
                      rtoData.displayNameStatus === "success" ? true : false
                    }
                    disabled
                  />
                  {rtoData.displayNameStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Display Name should be maximum 20 characters long and can
                        contain only alphabets
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
              )}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    RTO Code*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="rtoCode"
                  placeholder="eg. CHN-RTO-001"
                  value={rtoData.rtoCode}
                  onChange={handleRTODataChange}
                  error={rtoData.rtoCodeStatus === "error" ? true : false}
                  success={rtoData.rtoCodeStatus === "success" ? true : false}
                />
                {rtoData.rtoCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      RTO Code should be maximum 20 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    State*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="state"
                  value={rtoData.state}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleRTODataChange} //selectedValue, event
                  options={stateOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={rtoData.stateStatus === "error" ? true : false}
                  success={rtoData.stateStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    District*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="district"
                  value={rtoData.district}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleRTODataChange} //selectedValue, event
                  options={districtOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={rtoData.districtStatus === "error" ? true : false}
                  success={rtoData.districtStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    City*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="city"
                  value={rtoData.city}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleRTODataChange} //selectedValue, event
                  options={cityOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={rtoData.cityStatus === "error" ? true : false}
                  success={rtoData.cityStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    RTO Region*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="rtoRegion"
                  value={rtoData.rtoRegion}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleRTODataChange} //selectedValue, event
                  options={rtoRegionOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={rtoData.rtoRegionStatus === "error" ? true : false}
                  success={rtoData.rtoRegionStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    RTO Zone*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="rtoZone"
                  value={rtoData.rtoZone}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleRTODataChange} //selectedValue, event
                  options={rtoZoneOptions?.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={rtoData.rtoZoneStatus === "error" ? true : false}
                  success={rtoData.rtoZoneStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Actve
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={rtoData.isActive}
                      onChange={(e) =>
                        handleRTODataChange({
                          target: {
                            name: "isActive",
                            value: e.target.checked,
                          },
                        })
                      }
                      color="primary"
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {rtoData.isActive ? "Yes" : "No"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="outlined"
            color="dark"
            onClick={() => {
              navigate("/motor-master/motor-RTO");
            }}
          >
            Cancel
          </MaterialButton>
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmit}
          >
            Submit
          </MaterialButton>
        </MaterialBox>
      </div>
    </>
  );
};
